import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToProducts = () => {
    document.getElementById('productos')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-54">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/oK8GL4s4HpDqCyMQfyXaWo/ChatGPT_Image_24_feb_2026_23_42_26.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-55">
        {/* Soft overlay to ensure text readability while keeping the bright Nordic feel */}
        <div className="absolute inset-0 bg-stone-900/40 mix-blend-multiply" data-id="element-56" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 via-transparent to-transparent" data-id="element-57" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 text-center flex flex-col items-center" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl bg-white/95 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-2xl border border-white/20" data-id="element-59">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="text-[#C9A96E] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-60">
            Cocina y Dulces Rentables
          </motion.span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-stone-800 leading-tight mb-6" data-id="element-61">
            Convertí tu cocina en un negocio rentable desde casa
          </h1>

          <p className="text-lg md:text-xl text-stone-600 mb-4 font-medium" data-id="element-62">
            Elegí cómo querés empezar hoy: viandas, dulces o eventos
          </p>

          <p className="text-stone-500 mb-8 max-w-xl mx-auto" data-id="element-63">
            No necesitás experiencia ni inversión grande. Solo empezar.
          </p>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToProducts} className="bg-[#5B9A6F] hover:bg-[#4A8A5E] text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors duration-300 shadow-lg shadow-[#5B9A6F]/25 hover:shadow-xl hover:shadow-[#5B9A6F]/35" data-id="element-64">
            QUIERO EMPEZAR
          </motion.button>
        </motion.div>
      </div>
    </section>;
}